
    // this file was auto generated by python script
    import Disc from './Disc';
    export default Disc;
    